import { formatDataCell } from '@/creditflowresearch/ui/components/deals/helpers';

const CommonCell = ({ row, cellName }) => formatDataCell(row[cellName]);

export default CommonCell;
